import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useExperiment } from "@hopper-b2b/experiments";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import styles from "./SignInBanner.module.scss";
import { useSessionContext } from "@/components/AuthModule/SessionContext";

export const SignInBanner = () => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "SignInBanner");

  const { sessionInfo, elevateUser } = useSessionContext();
  const isSoftAuthCheckout = useExperiment("SoftAuthCheckout", "NoStepUp");
  const isHardAuth = sessionInfo?.userDetails?.hardAuth ?? false;

  if (!isSoftAuthCheckout || isHardAuth) {
    return null;
  }

  return (
    <button
      className={block}
      onClick={() =>
        elevateUser(window.location.pathname + window.location.search)
      }
    >
      <div className={cn("icon-wrapper")}>
        <Icon className={cn("icon")} iconName={IconNameEnum.offers__tag} />
      </div>
      <span className={cn("copy")}>
        <strong>{t("home.loginBanner.title")}</strong>
        {" \u2022 "}
        {t("home.loginBanner.message")}
      </span>
    </button>
  );
};
